import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home';
import About from './pages/About';
import AssociationMembers from './pages/AssociationMembers';
import Contact from './pages/Contact';
import Gallary from './pages/Gallary';
import Release from './pages/Release';
import ScrollToTop from './components/ScrollToTop';
import AdminDashboard from './admin/AdminDashboard';
import DesignationList from './admin/Designation/designationsList';
import EditDesignation from './admin/Designation/EditDesignation';
import AddProduct from './admin/Designation/designationsAdd';


import AdminLayout from './admin/AdminLayout';


import Addperson from './admin/person/Addperson';
import Editperson from './admin/person/Editperson';
import PersonList from './admin/person/personList';

import ReleaseList from './admin/Release/ReleaseList';
import ReleaseAdd from './admin/Release/ReleaseAdd';
import ReleaseEdit from './admin/Release/ReleaseEdit';

import GallaryList from './admin/gallary/GallaryList';
import GallaryAdd from './admin/gallary/GallaryAdd';
import GallaryEdit from './admin/gallary/GallaryEdit';

import InquiriesList from './admin/Inquiries/inquiriesList';

import Login from './admin/Login';



function App() {
  return (
    <div>


      <ScrollToTop />
      <Navbar />
      <div className='mt-0'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/members" element={<AssociationMembers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallary />} />
          <Route path="/releases" element={<Release />} />


          <Route path="login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>

            {/* DEFAULT ADMIN PAGE */}
            <Route index element={<AdminDashboard />} />


            {/* PRODUCT ROUTES */}
            <Route path="DesignationList" element={<DesignationList />} />
            <Route path="add-designation" element={<AddProduct />} />
            <Route path="EditDesignation/:id" element={<EditDesignation />} />

            <Route path="personList" element={<PersonList />} />
            <Route path="add-person" element={<Addperson />} />
            <Route path="edit-person/:id" element={<Editperson />} />

            <Route path="ReleaseList" element={<ReleaseList />} />
            <Route path="add-release" element={<ReleaseAdd />} />
            <Route path="edit-release/:id" element={<ReleaseEdit />} />

            <Route path="GallaryList" element={<GallaryList />} />
            <Route path="add-gallary" element={<GallaryAdd />} />
            <Route path="edit-gallary/:id" element={<GallaryEdit />} />

            <Route path="InquiriesList" element={<InquiriesList />} />

            {/* DESIGNATION ROUTES */}
            {/* <Route path="designations" element={<Designations />} /> */}

            {/* PERSON ROUTES */}
            {/* <Route path="persons" element={<Persons />} /> */}

          </Route>

        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
